module.exports = __webpack_public_path__ + "static/media/2_xs.239d68b1.png";